import ImageWithFallback from './ImageWithFallback';
import * as S from './styles';

const LINKS_RAPIDOS = [
  { label: 'Nossas Soluções', href: 'https://www.bellinatiperez.com.br/nossas-solucoes/' },
  { label: 'A Bellinati Perez', href: 'https://www.bellinatiperez.com.br/sobre/' },
  { label: 'Ouvidoria', href: 'https://www.bellinatiperez.com.br/ouvidoria/' },
];

const LINKS_LEGAIS = [
  {
    label: 'Política de privacidade',
    href: 'https://www.bellinatiperez.com.br/politica-de-privacidade/',
  },
  {
    label: 'Igualdade Salarial - Advocacia Bellinati Perez',
    href: 'assets/files/RelatorioIgualdadeSalarialLote_2026_ADVOCACIA.pdf',
  },
  {
    label: 'Igualdade Salarial - BP Gestão',
    href: 'assets/files/RelatorioIgualdadeSalarialLote_2026_BP GESTÃO.pdf',
  },
];

interface Props {
  logoUrl?: string;
  logoAlt: string;
}

function Footer({ logoUrl, logoAlt }: Props) {
  return (
    <S.FooterBar>
      <S.FooterInner>
        <S.FooterLogo as={ImageWithFallback} src={logoUrl} alt={logoAlt} />

        <S.FooterColumns>
          <div>
            <S.FooterTitle>Sobre a Parceria</S.FooterTitle>
            <S.FooterText>
              Parceria autorizada oferecendo soluções em crédito com seriedade, competência e
              inovação.
            </S.FooterText>
          </div>

          <div>
            <S.FooterTitle>Links Rápidos</S.FooterTitle>
            <S.FooterList>
              {LINKS_RAPIDOS.map((link) => (
                <li key={link.label}>
                  <S.FooterLink href={link.href} target="_blank" rel="noopener noreferrer">
                    {link.label}
                  </S.FooterLink>
                </li>
              ))}
            </S.FooterList>
          </div>

          <div id="contato">
            <S.FooterTitle>Contato</S.FooterTitle>
            <S.FooterStack>
              <S.FooterText>Telefone: (41) 3207-9291</S.FooterText>
              <S.FooterText>Endereço: Avenida Duque de Caxias, 882 – Maringá</S.FooterText>
              <S.FooterText>CNPJ: 13.600.461/0001-47</S.FooterText>
              <S.FooterText>
                E-mail:{' '}
                <S.FooterInlineLink href="mailto:contatobp@bellinatiperez.com.br">
                  contatobp@bellinatiperez.com.br
                </S.FooterInlineLink>
              </S.FooterText>
            </S.FooterStack>
          </div>
        </S.FooterColumns>

        <S.FooterBottom>
          <S.FooterCopyright>
            © {new Date().getFullYear()} Bellinati Perez. Todos os direitos reservados.
          </S.FooterCopyright>

          <S.FooterLegal>
            {LINKS_LEGAIS.map((link) => (
              <S.FooterLink key={link.label} href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </S.FooterLink>
            ))}
          </S.FooterLegal>
        </S.FooterBottom>
      </S.FooterInner>
    </S.FooterBar>
  );
}

export default Footer;
